import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";

export const Faq = ({ faqs, title = "Domande frequenti" }) => {
  const [open, setOpen] = useState(0);

  return (
    <section className="mx-auto max-w-4xl px-5 py-16 lg:px-8 lg:py-24" data-testid="faq">
      <Reveal>
        <p className="text-center text-xs font-semibold uppercase tracking-widest text-xmove-orange">FAQ</p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold text-xmove-ink sm:text-4xl">{title}</h2>
      </Reveal>
      <div className="mt-10 space-y-3">
        {faqs.map((f, i) => {
          const isOpen = open === i;
          return (
            <Reveal key={i} delay={i * 0.04}>
              <div className={`overflow-hidden rounded-2xl border transition-colors ${isOpen ? "border-xmove-orange/40 bg-white shadow-soft" : "border-xmove-ink/10 bg-white"}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-question-${i}`}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left sm:px-6 sm:py-5"
                >
                  <span className="font-display text-[15px] font-bold text-xmove-ink sm:text-base">{f.q}</span>
                  <ChevronDown
                    size={19}
                    className={`shrink-0 text-xmove-orange transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                    >
                      <p className="px-5 pb-5 text-sm leading-relaxed text-xmove-muted sm:px-6" data-testid={`faq-answer-${i}`}>
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};
